const MILES_MULTIPLIER = 1.60934;

export class Distance {
    readonly inKm: number;

    constructor(readonly value: number, readonly unit: Unit) {
        this.inKm = this.unit === Unit.Kilometers ? this.value : this.value * MILES_MULTIPLIER;
    }

    increase(by: number) {
        return new Distance(this.value + by, this.unit);
    }

    decrease(by: number) {
        return new Distance(this.value - by, this.unit);
    }
}

export enum Unit {
    Kilometers,
    Miles,
}
